import { Link } from 'react-router-dom';

export const Menu = () => {
  return (
    <div className='header-logo-menu sticker'>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-2 col-12'>
            <div className='logo'>
              <a href='index.html'>
                <img
                  src='/img/logo.png'
                  style={{ width: '150px' }}
                  alt='1er Foro'
                />
              </a>
            </div>
          </div>
          <div className='col-lg-2 col-12'>
            <div className='logo'>
              <a href='index.html'>
                <img
                  src='/img/1.png'
                  style={{ width: '150px', height: '70px' }}
                  alt='1er Foro'
                />
              </a>
            </div>
          </div>
          <div className='col-lg-2 col-12'>
            <div className='logo'>
              <a href='index.html'>
                <img
                  src='/img/creson.png'
                  style={{ width: '150px', height: '70px' }}
                  alt='1er Foro'
                />
              </a>
            </div>
          </div>
          <div className='col-lg-6 col-12'>
            <div className='mainmenu-area pull-right'>
              <div className='mainmenu d-none d-lg-block'>
                <nav>
                  <ul id='nav'>
                    <li className='current'>
                      <Link to='/'>Inicio</Link>
                    </li>
                    <li>
                      <Link to='/programa'>Programa</Link>
                    </li>
                    <li>
                      <Link to='/registro/1'>Registro</Link>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
